import { useNavigate, useSearch } from '@tanstack/react-router';
import { useCallback } from 'react';

export function useOverlayParam(name: string, key = 'sheet') {
  const search: Record<string, unknown> = useSearch({ strict: false });
  const navigate = useNavigate();
  const open = search[key] === name;
  const setOpen = useCallback(
    (next: boolean) => {
      void navigate({
        to: '.',
        search: (prev: Record<string, unknown>) => {
          const { [key]: _current, ...rest } = prev;
          return next ? { ...rest, [key]: name } : rest;
        },
        replace: !next,
      });
    },
    [navigate, key, name],
  );
  return [open, setOpen] as const;
}
